//Generated File 
export const DeleteLine = `DeleteLine`;
export const InsertLine = `InsertLine`;
export const PrevalidateColumns = `PrevalidateColumns`;
